import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { CallToAction } from '../styling/styles';
import BREAK_POINTS from '../styling/media-queries';

export const ProtectItCta = styled(Link)`
  ${CallToAction}
  font-weight: 600;
  font-size: 16px;
  margin-top: 37px;
  @media ${BREAK_POINTS.mobileBig} {
    font-size: 20px;
    padding-left: 50px;
    padding-right: 50px;
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components.tsx